<template>
  <el-col class="chart-module" :lg="$root.barWidth">
    <div
      class="sub-view"
      style="min-height: 240px; padding: 0; text-align: center"
    >
      <el-row style="background-color: #94E3FF; padding: 1px 5px 1px 5px; color: #125478">
        <span style="font-weight: bold; font-size: 13px; float: left">{{
          displayTitle
        }}</span>
        <i
          class="el-icon-close"
          v-if="$root.editMode"
          @click="$root.realTimeOnClose(title)"
        ></i>
      </el-row>
      <el-row
        style="
          text-align: center;
          font-size: 80px;
          color: #ffc107;
          line-height: 170px;
        "
      >
        <span>{{ $root.chatNgCount }}</span>
      </el-row>
      <hr style="color: #f8f8f8; opacity: 0.5" />
      <el-row
        style="padding: 0 10px 0 10px; line-height: 22px; font-size: 12px"
      >
        <!-- <el-col class="opacity"
          >{{ $root.htmlConst.cons_111_daily_count }}：{{
            dailyNgWordCount
          }}</el-col
        > -->
        <!-- todo: do in the future -->
        <el-col class="opacity">{{ $root.htmlConst.cons_111_daily_count }}：0</el-col>
      </el-row>
    </div>
  </el-col>
</template>

<script>
import api from "@/api";
export default {
  name: "ChatNgWordsAlertCount",
  props: ["title", "displayTitle"],
  data() {
    return {
      dailyNgWordCount: 0,
    };
  },
  created() {
    let self = this;
    api.getDailyNgWordsCount('MANUAL_CHAT_MODE').then(
      (res) => {
        if (res && res.data) {
          self.dailyNgWordCount = res.data.dailyNgWordCount;
        }
      },
      (err) => {
        console.log(err);
      }
    );
  },
};
</script>
<style>
.el-col-lg-4 {
  width: 16.666666%;
}
.el-col-lg-5 {
  width: 20%;
}
.el-col-lg-6 {
  width: 25%;
}
.el-col-lg-8 {
  width: 33.3333%;
}
</style>
